/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonalRequisitionIncludeFilterInner } from './personalRequisitionIncludeFilterInner';
import { PersonalRequisitionFields } from './personalRequisitionFields';
import { AcademicLevelFilterOrder } from './academicLevelFilterOrder';


export interface PersonalRequisitionFilter1 { 
    offset?: number;
    limit?: number;
    skip?: number;
    order?: AcademicLevelFilterOrder;
    fields?: PersonalRequisitionFields;
    include?: Array<PersonalRequisitionIncludeFilterInner>;
}

